import { Entity, Field } from "typegraph";

import { ID } from "common/entities/IEntity";
import LaunchURL from "common/entities/LaunchURL";
import Product from "./Product";
import { PreTestSubscription, Subscription } from "./Subscription";

@Entity({one: "entry", many: "entries"})
export class Entry {

	@Field()
	public id: ID;

	@Field()
	public displayName?: string;

	@Field({entity: Product})
	public product: Product;

	@Field({entity: Subscription})
	public subscription: Subscription;

	@Field({entity: LaunchURL})
	public launchURL: LaunchURL;

}

// tslint:disable-next-line
export class PreTestEntry {

	@Field()
	public id: ID;

	@Field()
	public displayName?: string;

	@Field({entity: Product})
	public product: Product;

	// separate class for this field (need to look for subscription tags here)
	@Field({entity: PreTestSubscription})
	public subscription: PreTestSubscription;

	@Field({entity: LaunchURL})
	public launchURL: LaunchURL;

}



// WEBPACK FOOTER //
// ./src/panels/program/entities/Entry.ts